/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import { Page, ProductLink } from '../components';
import { getImagePath, getCart, formatPrice } from '../utilities';

export default class extends React.Component {
  state = {
    cart: {},
    btnDisabled: true,
  };

  /***
   * We have to use componentDidMount to fetch products in sessionStorage
   * getInitialProps will not work because there is no `window` on the server-side
   */
  async componentDidMount() {
    const cart = await getCart();
    if (cart) {
      this.setState({
        cart: cart,
        btnDisabled: false,
      });
    }
  }

  render() {
    const { cart } = this.state;
    console.log(cart);
    this.totalPrice = 0;

    return (
      <Page className={'CartPage'} title={'Cart'}>
        <section className="featured watchlist">
          <div className="container watchlist-container">
            <div className="featured_videos">
              <h3>Your Cart:</h3>
              <div className="row">
                {Object.keys(cart).map((key, index) => {
                  return this.renderCartItems(cart[key], index);
                })}
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="col-md-4" />
                  <div className="col-md-4">
                    <h3>Total: {formatPrice(this.totalPrice)}</h3>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="btn-group" role="group">
                  <button
                    type="button"
                    id="purchase-products"
                    className="btn btn-info"
                    disabled={this.state.btnDisabled}
                    onClick={(e) => {
                      this.handlePurchase(cart);
                    }}
                  >
                    PURCHASE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Page>
    );
  }

  handlePurchase = (cart) => {
    if (typeof window === 'undefined') {
      return;
    }
    if (!window.mParticle) {
      return setTimeout(this.handleParticleEvent, 1000, cart);
    }
    const { mParticle } = window;
    const purchaseID = btoa(Math.random()).substring(0, 12);
    const transactionAttributes = {
      Id: purchaseID,
      Revenue: 0,
      Tax: 0,
      Shipping: 0,
    };
    const products = Object.keys(cart).map((key) => {
      const product = cart[key];
      const { name, sku, price, quantity } = product;
      transactionAttributes.Revenue =
        transactionAttributes.Revenue + price.current * quantity;
      return mParticle.eCommerce.createProduct(
        name,
        sku,
        price.current,
        quantity
      );
    });
    mParticle.eCommerce.logProductAction(
      mParticle.ProductActionType.Purchase,
      products,
      null,
      null,
      transactionAttributes
    );
    return alert(
      `You have successfully purchased these items with the ID of ${purchaseID}`
    );
  };

  renderCartItems = (item, index) => {
    const { image, name, price, quantity, sku, color, size } = item;
    const rowPrice = formatPrice(price.current * quantity);
    this.totalPrice = this.totalPrice + price.current * quantity;
    return (
      <div key={index} className="col-md-12">
        <div className={'row'} style={{ marginBottom: '20px' }}>
          <ProductLink link={sku}>
            <div
              className="col-md-4"
              style={{
                backgroundImage: `url(${getImagePath(image)})`,
                backgroundSize: 'cover',
                width: '150px',
                height: '150px',
                marginRight: '20px',
              }}
            />
          </ProductLink>
          <div className="col-md-4">
            <ProductLink link={sku}>
              <h4>{name}</h4>
            </ProductLink>
            <h5>Color: {color}</h5>
            <h5>Size: {size}</h5>
            <h5>Quantity: {quantity}</h5>
          </div>
          <div className="col-md-4">
            <h4>{rowPrice}</h4>
          </div>
        </div>
      </div>
    );
  };
}
